import { createApp } from "./main";
import { useMenuStore } from "./stores";
import "./assets/css/main.css";

const { app, router, pinia } = createApp();

// Pinia-State aus SSR übernehmen
if (window.__PINIA_STATE__) {
  pinia.state.value = window.__PINIA_STATE__;
}

router.isReady().then(() => {
  app.mount("#app");

  // ✅ Client-Fallback: Navigation laden, falls leer
  const menuStore = useMenuStore(pinia);

  if (menuStore.main_menu.length === 0) {
    menuStore.updateAllNavigations().catch((err) => {
      console.error("Client fallback: failed to load navigation", err);
    });
  }
});
